import React from "react";
import {authRoles} from "app/auth/index.js";

import i18next from "../../../i18n.js";

import en from "./i18n/en.js";
import fr from "./i18n/fr.js";

i18next.addResourceBundle("en", "settings", en);
i18next.addResourceBundle("fr", "settings", fr);

const settingsConfig = {
  settings: {layout: {config: {}}},
  auth: authRoles.user,
  routes: [
    {
      path: "/settings",
      exact: true,
      component: React.lazy(() => import("./Settings.js")),
    },
  ],
};

export default settingsConfig;
